import { useEffect, useState } from 'react';

import type { MutableRefObject } from 'react';

export const useSentinel = <T extends HTMLElement>(
  ref: MutableRefObject<T>
) => {
  const [isIntersecting, setIsIntersecting] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      setIsIntersecting(entries[0].isIntersecting);
    });

    observer.observe(ref.current);

    return () => {
      observer.disconnect();
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return {
    isIntersecting,
  };
};
